/*
 *
 * titleAPI.js
 *
 */

import Axios from "axios";

const titleAPI = {
    fetchByID: async data => await Axios.get(`${window.API_URL}/title/get.php?titleID=${data.titleID}`),
    fetchAll: async () => await Axios.get(`${window.API_URL}/title/get.php`),
    create: async data => await Axios.post(`${window.API_URL}/title/create.php`, {
        name:data.name
    }),
    setName: async data => await Axios.post(`${window.API_URL}/title/setName.php`, {
        titleID:data.titleID,
        titleName:data.titleName
    }),
    delete: async data => await Axios.post(`${window.API_URL}/title/delete.php`, {
        titleID:data.titleID
})
};

export default titleAPI;